import React from 'react'

import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import { useTranslate } from 'react-admin'

const useStyles = makeStyles({
  descriptionField: {
    whiteSpace: 'nowrap',
    fontSize: '14px',
    lineHeight: '16.41px',
  },
})

export const EventPaymentSubTypeField = ({ source, basePath, ...props }) => {
  const classes = useStyles()
  const translate = useTranslate()

  return (
    <Typography {...props}>
      {props.record[source]?.toLowerCase() === 'advance' && (
        <span className={classes.descriptionField}>
          {translate('resources.payments.messages.invoiceAdvance')}
        </span>
      )}
      {props.record[source]?.toLowerCase() === 'settlement' && (
        <span className={classes.descriptionField}>
          {translate('resources.payments.messages.invoiceBalance')}
        </span>
      )}
      {props.record[source]?.toLowerCase() === 'forward' && (
        <span className={classes.descriptionField}>
          {translate('resources.payments.messages.collectionForward')}
        </span>
      )}
    </Typography>
  )
}
